import './ListDetails.scss'

import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Loading, updateTitle, Page } from 'hb4e-ui-core'
import { Pagination } from 'hb4e-ui-core-ui'
import { List } from 'hb4e-ui-context'

import EmptyList from './EmptyList/EmptyList'
import ListDetailsHeader from './ListDetailsHeader/ListDetailsHeader'
import ListProducts from './ListProducts/ListProducts'
import { fetchList, setReorderableItems } from '../../../../actions'
import { selectActiveList, selectIsReordering, selectList, selectReorderableItems } from '../../../../reducers'
import { ListsPageTitle, LIST_ITEMS_PAGE_LIMIT } from '../../../../constants'

const ListDetails = ({ listID }) => {
  const dispatch = useDispatch()
  const basicList = useSelector((state) => selectList(state, listID)) || List.getStaticListForID(listID)
  const { isFetching, list: detailedList } = useSelector((state) => selectActiveList(state))
  const isReordering = useSelector(selectIsReordering)
  const reorderableItems = useSelector(selectReorderableItems) ?? []

  // fetch the list data on component mount if the list is not empty
  useEffect(() => {
    if (basicList && !basicList.isEmpty()) {
      dispatch(fetchList(basicList.getServerID(), new Page({ number: 1, limit: LIST_ITEMS_PAGE_LIMIT })))
    }
  }, [basicList, dispatch])

  // updates the page title based on active list
  useEffect(() => {
    let pageTitle = ListsPageTitle.MY_LISTS

    if (basicList?.isSavedItemsList()) {
      pageTitle = ListsPageTitle.SAVED_ITEMS
    } else if (basicList?.isFreeTrialsList()) {
      pageTitle = ListsPageTitle.FREE_TRIALS
    } else if (basicList?.isPurchasedList()) {
      pageTitle = ListsPageTitle.PURCHASED_ITEMS
    } else if (basicList?.isPersonalList()) {
      pageTitle = `${basicList?.getName()}`
    }

    dispatch(updateTitle(pageTitle))
  }, [listID])

  // When loading a new list, if the reorderable items array is empty, populate it with the list's items
  useEffect(() => {
    if (reorderableItems?.length === 0) {
      const reorderableItems = detailedList?.getItems().sort((a, b) => a.sortOrder - b.sortOrder)

      dispatch(setReorderableItems(reorderableItems))
    }
  }, [detailedList, reorderableItems.length, dispatch])

  const renderPagination = () => {
    if (isReordering || detailedList?.getPaginatedItems()?.totalElements <= LIST_ITEMS_PAGE_LIMIT) {
      return null
    }

    return (
      <div className="list-details__pagination-container">
        <Pagination
          page={detailedList?.getPaginatedItems()}
          onChange={(pageNumber) => {
            dispatch(
              fetchList(detailedList?.getServerID(), new Page({ number: pageNumber, limit: LIST_ITEMS_PAGE_LIMIT })),
            )
            window.scrollTo(0, 0)
          }}
        />
      </div>
    )
  }

  if (!basicList || (!detailedList && !basicList.isEmpty())) {
    return null
  } else if (isFetching) {
    return <Loading />
  }

  return (
    <>
      <ListDetailsHeader list={basicList} />
      {basicList.isEmpty() ? (
        <EmptyList />
      ) : (
        <>
          <ListProducts list={detailedList} />
          {renderPagination()}
        </>
      )}
    </>
  )
}

export default ListDetails
